<template>
  <div class="wrapper-404">
    <div class="center-content">
      <img src="../assets/404.png" alt="">
      <div>您访问的页面不存在</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style lang="stylus" scoped>
.wrapper-404 {
  position absolute
  height 100%
  width 100%
  .center-content {
    position absolute
    top 50%
    left 50%
    transform translate(-50%,-50%)
    img{
      display block
      width 300px
      height 300px
    }
    div{
      text-align center
      color red
      font-size 18px
    }
  }
}
</style>
